import script from "./AssetDetailInfoContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetDetailInfoContent.vue?vue&type=script&setup=true&lang=ts"

import "./AssetDetailInfoContent.vue?vue&type=style&index=0&id=28035e11&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28035e11"]])

export default __exports__